import { graphql } from "~/gql";

export const DELETE_LIBRARY_DISBURSEMENTS = graphql(/* GraphQL */ `
  mutation DeleteLibraryDisbursements($data: [Int!]!) {
    deleteLibraryDisbursements(data: $data) {
      disbursementIds
    }
  }
`);
